<form #form="ngForm" (ngSubmit)="confirmSaveItem(itemToSave)" novalidate>

  <div class="modal-header">
    <h5 class="modal-title">{{ dialogTitle }}</h5>
    <button type="button" class="btn-close" aria-label="Fermer" (click)="activeModal.dismiss()"></button>
  </div>

  <div class="modal-body cr-body">

    <!-- Client et apporteur : uniquement à la création -->
    <section class="cr-section" *ngIf="!itemToSave.id">
      <h6>Client</h6>
      <div class="cr-grid">
        <div class="cr-field cr-span-2">
          <div class="cr-label-row">
            <span class="form-label">Client</span>
            <button type="button" class="cr-link" (click)="openAddClientModal('add')">
              <i class="material-icons-outlined" aria-hidden="true">person_add</i>Nouveau client
            </button>
          </div>
          <app-client-search-select name="client_id" [hotelId]="user.hotel_id" [groupeId]="user.groupe_id"
            [userId]="user.id" [value]="itemToSave.client_id"
            (clientChange)="itemToSave.client_id = $event?.id; onClientChange($event)">
          </app-client-search-select>
          <div *ngIf="form.submitted && !itemToSave.client_id" class="invalid-feedback d-block">Choisissez un client.</div>
        </div>

        <div class="cr-field cr-span-2">
          <div class="cr-label-row">
            <label for="apporteur_search_key" class="form-label">Apporteur <span class="cr-optional">(facultatif)</span></label>
            <button type="button" class="cr-link" (click)="openAddApporteurModal('add')">
              <i class="material-icons-outlined" aria-hidden="true">person_add</i>Nouvel apporteur
            </button>
          </div>
          <div class="cr-input-group">
            <input id="apporteur_search_key" name="apporteur_search_key" type="text" class="form-control"
              placeholder="Nom ou téléphone" [(ngModel)]="apporteur_search_key" #apporteurSearchCtrl="ngModel"
              (keydown.enter)="$event.preventDefault(); onSearchApporteur()" />
            <button type="button" class="btn btn-outline-secondary" (click)="onSearchApporteur()" aria-label="Rechercher l'apporteur">
              <i class="material-icons-outlined" aria-hidden="true">search</i>
            </button>
          </div>
        </div>

        <div *ngIf="itemsApporteur?.length" class="cr-field cr-span-2">
          <label for="apporteur_id" class="form-label">Apporteur trouvé</label>
          <select id="apporteur_id" name="apporteur_id" class="form-select" [(ngModel)]="itemToSave.apporteur_id"
            #apporteurCtrl="ngModel">
            <option value="" disabled selected>Choisir un apporteur</option>
            <option *ngFor="let a of itemsApporteur" [value]="a.id">
              {{ a.nom | titlecase }} {{ a.prenom | titlecase }} · {{ a.telephone }}
            </option>
          </select>
        </div>
      </div>
    </section>

    <section class="cr-section">
      <h6>Séjour</h6>
      <div class="cr-grid">
        <div class="cr-field">
          <label for="service_id" class="form-label">Formule</label>
          <select id="service_id" name="service_id" class="form-select" [(ngModel)]="itemToSave.service_id"
            (change)="onSelectService()" [disabled]="itemToSave.id" required #serviceCtrl="ngModel">
            <option value="" disabled selected>Choisir une formule</option>
            <option *ngFor="let s of itemsService" [value]="s.id">{{ s.libelle | titlecase }}</option>
          </select>
          <div *ngIf="serviceCtrl.invalid && serviceCtrl.touched" class="invalid-feedback d-block">Choisissez une formule.</div>
        </div>

        <div class="cr-field">
          <label for="chambre_id" class="form-label">Chambre</label>
          <select id="chambre_id" name="chambre_id" class="form-select" [(ngModel)]="itemToSave.chambre_id"
            (change)="calculatePrice()" required #chambreCtrl="ngModel">
            <option value="" disabled selected>Choisir une chambre</option>
            <option *ngFor="let c of itemsChambre" [value]="c.id">
              {{ c.libelle | titlecase }} · {{ c.montant_service | IntegerFormatPipe }} FCFA
            </option>
          </select>
          <div *ngIf="chambreCtrl.invalid && chambreCtrl.touched" class="invalid-feedback d-block">Choisissez une chambre.</div>
        </div>

        <div class="cr-field">
          <span class="form-label">Arrivée</span>
          <div class="cr-datetime">
            <input id="debut_reservation" name="debut_reservation" class="form-control" placeholder="jj/mm/aaaa"
              aria-label="Date d'arrivée" [(ngModel)]="itemToSave.debut_reservation" #debutCtrl="ngModel"
              autocomplete="off" bsDatepicker [minDate]="minDate" [bsConfig]="datePickerConfig" />
            <input id="heure_debut_reservation" name="heure_debut_reservation" type="time" class="form-control"
              aria-label="Heure d'arrivée" [(ngModel)]="itemToSave.heure_debut_reservation" disabled required
              #heureDebutCtrl="ngModel" />
          </div>
          <div *ngIf="debutCtrl.invalid && debutCtrl.touched" class="invalid-feedback d-block">Indiquez la date d'arrivée.</div>
        </div>

        <div class="cr-field">
          <span class="form-label">Départ</span>
          <div class="cr-datetime">
            <input id="fin_reservation" name="fin_reservation" class="form-control" placeholder="jj/mm/aaaa"
              aria-label="Date de départ" [(ngModel)]="itemToSave.fin_reservation" (bsValueChange)="onSelectDateFin($event)"
              [disabled]="current_service.codification !== 'SEJOUR'" required #finCtrl="ngModel" autocomplete="off"
              bsDatepicker [minDate]="myDate" [bsConfig]="datePickerConfig" />
            <input id="heure_fin_reservation" name="heure_fin_reservation" type="time" class="form-control"
              aria-label="Heure de départ" [(ngModel)]="itemToSave.heure_fin_reservation" disabled required
              #heureFinCtrl="ngModel" />
          </div>
          <div *ngIf="finCtrl.invalid && finCtrl.touched" class="invalid-feedback d-block">Indiquez la date de départ.</div>
        </div>
      </div>
    </section>

    <section class="cr-section">
      <h6>Montant</h6>
      <div class="cr-grid">
        <div class="cr-field">
          <label for="montant_total" class="form-label">Total <span class="cr-optional">(calculé)</span></label>
          <div class="cr-amount">
            <input id="montant_total" name="montant_total" type="text" appMontant class="form-control"
              [(ngModel)]="itemToSave.montant_total" disabled #montantTotalCtrl="ngModel" />
            <span>FCFA</span>
          </div>
        </div>

        <div class="cr-field">
          <label for="montant_avance" class="form-label">Avance</label>
          <div class="cr-amount">
            <input id="montant_avance" name="montant_avance" type="text" appMontant class="form-control"
              [ngModel]="itemToSave.montant_avance" (ngModelChange)="itemToSave.montant_avance = $event; onCalculateMonnaie()" required
              [montantMax]="itemToSave.montant_total" #avanceCtrl="ngModel" />
            <span>FCFA</span>
          </div>
          <div *ngIf="avanceCtrl.invalid && avanceCtrl.touched" class="invalid-feedback d-block">
            <span *ngIf="avanceCtrl.errors?.['required']">Indiquez l'avance (0 si aucune).</span>
            <span *ngIf="avanceCtrl.errors?.['max']">L'avance ne peut pas dépasser le total ({{ itemToSave.montant_total | IntegerFormatPipe }} FCFA).</span>
          </div>
        </div>

        <ng-container *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
          <div class="cr-field">
            <label for="mode_reglement_id" class="form-label">Mode de règlement</label>
            <select id="mode_reglement_id" name="mode_reglement_id" class="form-select"
              [(ngModel)]="itemToSave.mode_reglement_id" required #modeRegCtrl="ngModel">
              <option value="" disabled selected>Choisir un mode</option>
              <option *ngFor="let m of itemsModeReglement" [value]="m.id"
                [disabled]="m.codification === 'FIDELITY' && !canUseFidelity()">
                {{ m.libelle | titlecase }}
                <ng-container *ngIf="m.codification === 'FIDELITY' && clientFidelite">
                  ({{ clientFidelite.montant_equivalent ?? 0 }} disponible)
                </ng-container>
              </option>
            </select>
            <div *ngIf="modeRegCtrl.invalid && modeRegCtrl.touched" class="invalid-feedback d-block">Choisissez un mode de règlement.</div>
          </div>

          <div class="cr-field">
            <label for="caisse_id" class="form-label">Caisse</label>
            <select id="caisse_id" name="caisse_id" class="form-select" [(ngModel)]="itemToSave.caisse_id" required
              #caisseCtrl="ngModel">
              <option value="" disabled selected>Choisir une caisse</option>
              <option *ngFor="let c of itemsUserCaisse" [value]="c.caisse_id">{{ c.caisse_libelle | titlecase }}</option>
            </select>
            <div *ngIf="caisseCtrl.invalid && caisseCtrl.touched" class="invalid-feedback d-block">Choisissez une caisse.</div>
          </div>

          <div class="cr-field">
            <label for="montant_recu" class="form-label">Montant reçu</label>
            <div class="cr-amount">
              <input id="montant_recu" name="montant_recu" type="text" appMontant class="form-control"
                [ngModel]="itemToSave.montant_recu" (ngModelChange)="itemToSave.montant_recu = $event; onCalculateMonnaie()" required #recuCtrl="ngModel" />
              <span>FCFA</span>
            </div>
            <div *ngIf="recuCtrl.invalid && recuCtrl.touched" class="invalid-feedback d-block">Indiquez le montant reçu.</div>
          </div>

          <div class="cr-field">
            <label for="monnaie_rendue" class="form-label">Monnaie à rendre</label>
            <div class="cr-amount">
              <input id="monnaie_rendue" name="monnaie_rendue" type="text" appMontant class="form-control"
                [(ngModel)]="itemToSave.monnaie_rendue" disabled #monnaieCtrl="ngModel" />
              <span>FCFA</span>
            </div>
          </div>

          <div class="cr-field cr-span-2">
            <label for="reference_reglement" class="form-label">Référence <span class="cr-optional">(facultatif)</span></label>
            <input id="reference_reglement" name="reference_reglement" type="text" class="form-control"
              placeholder="N° de transaction, de chèque…" [(ngModel)]="itemToSave.reference_reglement" #refCtrl="ngModel" />
          </div>
        </ng-container>
      </div>
    </section>

  </div>

  <div class="modal-footer cr-footer">
    <label for="img" class="cr-attach">
      <img *ngIf="imageDisplay" [src]="imageDisplay" alt="Aperçu de la pièce jointe" />
      <i *ngIf="!imageDisplay" class="material-icons-outlined" aria-hidden="true">attach_file</i>
      {{ imageDisplay ? "Remplacer l'image" : 'Joindre une image' }}
    </label>
    <input id="img" type="file" accept=".png, .jpg, .jpeg, .bmp" name="photo" (change)="uploadFile($event)" hidden />
    <span class="cr-hint" *ngIf="form.invalid">Renseignez les champs obligatoires pour enregistrer.</span>
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Annuler</button>
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Enregistrer la réservation</button>
  </div>

</form>
